module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-content m-t-xl b-gray-1 p-y-30 text-center",
    staticStyle: {
      "margin-bottom": "60px"
    }
  }, [_c('div', {
    staticClass: "wx-qr-wrp"
  }, [_c('div', {
    staticClass: "pay-title"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_vm._v("应付金额："), _c('span', {
    staticClass: "text-price"
  }, [_vm._v(_vm._s(_vm.weixinOrder.price / 100 || 0))]), _vm._v("元")]), _vm._v("\n      微信支付\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "b-gray-1",
    staticStyle: {
      "margin": "20px 0"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "298px",
      "width": "298px"
    },
    attrs: {
      "src": _vm.imgSrc
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "src": require("../assets/iphone-bj.png")
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wx-pay-desc text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/scan-code.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-i"
  }, [_vm._v("\n        请使用微信扫一扫 "), _c('br'), _vm._v("\n        扫描二维码支付\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49ddf625"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WeixinPay.vue
// module id = 604
// module chunks = 1